module.exports = __webpack_public_path__ + "img/SPI-Dessin-FG-584x584.c48e990f.webp";